import { render, staticRenderFns } from "./PeriodoPagoForm.vue?vue&type=template&id=58cadfa2&scoped=true"
import script from "./PeriodoPagoForm.vue?vue&type=script&lang=js"
export * from "./PeriodoPagoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cadfa2",
  null
  
)

export default component.exports